import React, { useState, useEffect } from 'react';
import moment from 'moment';

export default function Timer({ className, short, withoutDate, gmt, dateFormat }) {
  const [now, setNow] = useState(moment());

  const language = localStorage.language;

  useEffect(() => {
    const nextCall = (60 - now.second()) * 1000;
    let interval = null;
    setTimeout(() => {
      const newNow = gmt ? moment().zone(0) : moment();
      setNow(newNow);
      interval = setInterval(() => {
        const newNow = gmt ? moment().zone(0) : moment();
        setNow(newNow);
      }, 60000);
    }, nextCall);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [language, gmt]);

  let time = null;

  return (
    <div className={`timer ${className}`}>
      {!dateFormat &&       <span className="timer-time">
        {now.format('HH:mm')}
        {!!gmt && ' GMT'}
      </span>}
      {' '}
      {!withoutDate && <span className="timer-date">
        {short
          ? now.format('ddd, DD MMM YY')
          : now.format(dateFormat ? dateFormat : 'dddd, DD MMMM YYYY')}
      </span>}
    </div>
  );
}
